import * as actionTypes from 'constants/action-types';

/**
 * AI Conversations cache state
 * Maps targetFieldId to conversationId for maintaining conversation history
 */
export interface AiConversationCache {
  [targetFieldId: string]: string; // targetFieldId -> conversationId
}

export interface AiConversationsState {
  conversationCache: AiConversationCache;
}

export const SET_CONVERSATION_ID = 'SET_CONVERSATION_ID';
export const GET_CONVERSATION_ID = 'GET_CONVERSATION_ID';
export const CLEAR_CONVERSATION_ID = 'CLEAR_CONVERSATION_ID';
export const CLEAR_ALL_CONVERSATIONS = 'CLEAR_ALL_CONVERSATIONS';

interface SetConversationIdAction {
  type: typeof SET_CONVERSATION_ID;
  payload: {
    targetFieldId: string;
    conversationId: string;
  };
}

interface ClearConversationIdAction {
  type: typeof CLEAR_CONVERSATION_ID;
  payload: {
    targetFieldId: string;
  };
}

interface ClearAllConversationsAction {
  type: typeof CLEAR_ALL_CONVERSATIONS;
}

interface SwitchWorkspaceAction {
  type: typeof actionTypes.SWITCH_WORKSPACE;
  payload: number;
}

export type AiConversationsActionTypes =
  | SetConversationIdAction
  | ClearConversationIdAction
  | ClearAllConversationsAction
  | SwitchWorkspaceAction;
